var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lms__superadmin_auditlog_list_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'eventType',
                title: 'Event type',
                type: 'string'
            },
            {
                key: 'time',
                title: 'Time',
                type: 'string'
            },
            {
                key: 'affectedObject',
                title: 'Affected object',
                type: 'string'
            },
            {
                key: 'source',
                title: 'Source',
                type: 'string'
            },
            {
                key: 'result',
                title: 'Result',
                type: 'string'
            },
            {
                key: 'description',
                title: 'Description',
                type: 'string'
            }
        ],"items":_vm.items,"component-table-item":_vm.LmsSuperadminAuditLogListTableItem},on:{"emit-sort":_vm.handleSort,"emit-perform-get-items":_vm.emitPerformGetItems,"emit-empty-state-submit":function($event){return _vm.handleEmit({ message: 'emit-empty-state-submit' })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }